import { render, staticRenderFns } from "./BookingAssignmentCard.vue?vue&type=template&id=39ec5bbc&scoped=true&"
import script from "./BookingAssignmentCard.vue?vue&type=script&lang=js&"
export * from "./BookingAssignmentCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingAssignmentCard.vue?vue&type=style&index=0&id=39ec5bbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec5bbc",
  null
  
)

export default component.exports